import styled from 'styled-components';

import BorderBox from '../../../../../Common/BorderBox';

export default styled(BorderBox)`
	--gap: var(--spacing-x-large);
	display: flex;
	flex-direction: column;
	gap: var(--gap);
	padding: var(--gap);

	.user {
		display: flex;
		gap: inherit;
	}
`;
